import * as React from "react";

import { NavigateButton } from "affinityUI/elements/button";
import { Card } from "affinityUI/elements/card";
import { Grid } from "affinityUI/elements/grid";
import { Heading } from "affinityUI/structures/heading";
import { Layout } from "affinityUI/structures/layout";

export const SupportPage: React.FC = () => {
  return (
    <Layout title="Support" showBackBtn>
      <Grid>
        <Card>
          <Heading>
            <Heading.SectionTitle>Contact us</Heading.SectionTitle>
          </Heading>
          <address>
            <p>
              <strong>Telephone:</strong> +44 191 743 7348 <br />
              <strong>Email:</strong> <a href="mailto:support@entia.co">support@entia.co</a>
            </p>
            <p>
              <strong>Address:</strong> Entia, Lloyds Avenue House, 6 Lloyd&apos;s Ave, London EC3N 3AX
              <br />
              <strong>Support hours:</strong> 9am-5pm, Monday-Friday
            </p>
          </address>
        </Card>
        <Card>
          <Heading>
            <Heading.SectionTitle>Dashboard instructions</Heading.SectionTitle>
          </Heading>
          <p>Learn how to get the most out of the Entia Liberty dashboard.</p>
          <NavigateButton to="instructions">Read quick tips</NavigateButton>
        </Card>
        <Card>
          <Heading>
            <Heading.SectionTitle>Cookie Policy</Heading.SectionTitle>
          </Heading>
          <p>Learn more about Entia Ltd website and our third-party providers.</p>
          <NavigateButton to="cookie-policy">Read cookie policy</NavigateButton>
        </Card>
        <Card>
          <Heading>
            <Heading.SectionTitle>Entia device information and support </Heading.SectionTitle>
          </Heading>
          <p>Learn more about Entia Ltd website and our third-party providers.</p>
          <NavigateButton to="device-info">Learn more</NavigateButton>
        </Card>
      </Grid>
    </Layout>
  );
};
